/**
 * DictUnitCtl — контрол «Единица» справочника расходников (Д7, эталон
 * screen-21-dicts.js unitCtl:70-80): Dropdown single типовых единиц (полное
 * название + краткое серым в meta; у «пара» меты нет) + пункт «другая…» →
 * короткий инпут maxLength 8 с кнопкой-возвратом к типовым (сброс в «шт»).
 * UNITS/UNITFULL — UI-словарь модуля; в БД unit — свободный TEXT.
 */
import { useState } from "react";
import { Dropdown } from "../../components/shared";
import cfg from "./config.module.css";
import qcss from "./quests.module.css";
import css from "./dicts.module.css";

export const UNITS = ["шт", "м", "компл", "л", "кг", "пара"];
export const UNITFULL: Record<string, string> = {
  "шт": "штука", "м": "метр", "компл": "комплект", "л": "литр", "кг": "килограмм", "пара": "пара",
};

export interface DictUnitCtlProps {
  u: string;
  custom: boolean;
  onChange: (u: string, custom: boolean) => void;
}

export function DictUnitCtl({ u, custom, onChange }: DictUnitCtlProps) {
  const [dd, setDd] = useState<HTMLElement | null>(null);

  if (custom) {
    return (
      <span className={css.uwrap}>
        <input
          className={`${qcss.txt} ${css.w8}`}
          maxLength={8}
          placeholder="ед."
          value={u}
          onChange={(e) => onChange(e.target.value, true)}
        />
        <button
          type="button"
          className={cfg.teNumbtn}
          title="Выбрать из типовых"
          onClick={() => onChange("шт", false)}
        >
          <span className={`${css.chev} ${css.chev8}`}>▾</span>
        </button>
      </span>
    );
  }

  return (
    <span className={css.uwrap}>
      <button type="button" className={cfg.teNumbtn} onClick={(e) => setDd(e.currentTarget)}>
        {u} <span className={`${css.chev} ${css.chev8}`}>▾</span>
      </button>
      <Dropdown
        open={!!dd}
        anchor={dd}
        multi={false}
        selectedIds={[u]}
        items={[
          ...UNITS.map((x) => ({ id: x, label: UNITFULL[x] ?? x, meta: x === "пара" ? undefined : x })),
          { id: "__other", label: "другая…" },
        ]}
        onClose={() => setDd(null)}
        onCommit={(ids) => {
          const id = ids[0];
          if (id == null) return;
          if (id === "__other") onChange("", true);
          else onChange(String(id), false);
        }}
      />
    </span>
  );
}
